import { FC, ReactElement } from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import TableChartIcon from "@mui/icons-material/TableChart";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

interface FileIconProps {
  fileName?: string;
  fileType?: string;
}

export const FileIcon: FC<FileIconProps> = ({
  fileName,
  fileType,
}): ReactElement => {
  const safeName = fileName || "";
  const extension = safeName.split(".").pop()?.toLowerCase() || "";
  const iconStyle = { fontSize: 24 };

  if (extension === "pdf" || fileType?.includes("pdf")) {
    return <PictureAsPdfIcon sx={{ ...iconStyle, color: "#E53935" }} />;
  }
  if (["doc", "docx"].includes(extension) || fileType?.includes("word")) {
    return <DescriptionIcon sx={{ ...iconStyle, color: "#1565C0" }} />;
  }
  if (
    ["xls", "xlsx"].includes(extension) ||
    fileType?.includes("spreadsheet") ||
    fileType?.includes("excel")
  ) {
    return <TableChartIcon sx={{ ...iconStyle, color: "#2E7D32" }} />;
  }
  if (
    ["ppt", "pptx"].includes(extension) ||
    fileType?.includes("presentation") ||
    fileType?.includes("powerpoint")
  ) {
    return <SlideshowIcon sx={{ ...iconStyle, color: "#E65100" }} />;
  }
  if (
    ["png", "jpg", "jpeg", "gif", "webp", "svg"].includes(extension) ||
    fileType?.startsWith("image")
  ) {
    return <ImageIcon sx={{ ...iconStyle, color: "#7B1FA2" }} />;
  }
  return <InsertDriveFileIcon sx={{ ...iconStyle, color: "#757575" }} />;
};
